import { useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type ServiceabilityResult } from '../../api/logistics';

export function ServiceabilityPage() {
  const [results, setResults] = useState<ServiceabilityResult[]>([]);
  const [origin, setOrigin] = useState('110001');
  const [dest, setDest] = useState('560001');

  async function check() {
    setResults(await logisticsApi.serviceability({ origin_pincode: origin, dest_pincode: dest }));
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/logistics" className="text-sm text-slate-600 hover:underline">← Logistics hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Serviceability checker</h1>
      <div className="mt-4 flex gap-2">
        <input value={origin} onChange={(e) => setOrigin(e.target.value)} className="rounded border px-2 py-1 text-sm" />
        <input value={dest} onChange={(e) => setDest(e.target.value)} className="rounded border px-2 py-1 text-sm" />
        <button type="button" onClick={() => void check()} className="rounded bg-slate-900 px-3 py-1 text-sm text-white">Check</button>
      </div>
      <ul className="mt-6 space-y-2 text-sm">
        {results.map((r) => (
          <li key={r.carrier_code} className="rounded border p-3">
            {r.carrier_code}: {r.serviceable ? 'Serviceable' : 'Not serviceable'}
            {r.cod_available && ' · COD available'} · ~{r.estimated_days} days
          </li>
        ))}
      </ul>
    </div>
  );
}
